import { api } from '@/lib/api-client'
import type { IssueSeverity } from '@/shared/constants/issue-status'

import { RESOLUTION_TARGETS, type ResolutionTargets } from '../lib/resolution-targets'

interface RawAppConfig {
  resolution_eta_defaults?: {
    unit: string
    by_severity: Partial<Record<IssueSeverity, number>>
  }
}

/**
 * `GET /app-config` — consolidated static config (lifecycle v2). The
 * `resolution_eta_defaults` block carries the SUGGESTED per-severity resolution
 * targets (days) that replace the retired `/config/issue-resolution-targets`;
 * the per-issue `resolution_eta` the HOD sets is what actually drives overdue.
 * Any severity the response omits falls back to the FE default, so a partial
 * payload degrades safely.
 */
export async function getResolutionTargets(): Promise<ResolutionTargets> {
  const raw = await api.get<RawAppConfig>('/app-config', { suppressErrorToast: true })
  const bs = raw.resolution_eta_defaults?.by_severity ?? {}
  return {
    critical: bs.critical ?? RESOLUTION_TARGETS.critical,
    non_critical: bs.non_critical ?? RESOLUTION_TARGETS.non_critical,
  }
}
